<template>
  <div class="p-0 ml-2" v-if="canExportFeed">
    <div v-if="exporting == 100 || exporting == 0" class="d-flex align-items-center">
      <div class="mr-2">
        <delete-button :label="label" :remove="startExporting" :disabled="!loaded || exporting > 0" />
      </div>
      <i v-if="help" class="fas fa-question-circle text-light" title="Remove record" v-b-tooltip.hover="help"></i>
    </div>
    <div v-else>
      <div class="mb-3 text-center">
        {{ labelProgress }} are in progress <i class="far fa-spinner fa-spin fa-fw mr-2"></i>
      </div>
      <div class="progress flex-fill">
        <div class="progress-bar" role="progressbar" :style="`width: ${exporting}%;`">{{ exporting.toFixed(2) }}%</div>
      </div>
    </div>
  </div>
</template>
<script>
import { encodeOpts } from '../../../utils/encode-opts';
import { api_services } from '../../../api/api.index';
import { mapGetters } from 'vuex';
export default {
  name: 'ProductsFeeds',
  props: {
    url: {
      type: String,
      default: '/feeds'
    },

    help: {
      type: String
    },
    label: {
      type: String,
      default: 'Products to feeds'
    },
    labelProgress: {
      type: String,
      default: 'Feeds'
    },
    isService: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loaded: false,
      info: null,
      timeOut: null,
      timeoutTime: 0,
      exporting: 0,
      isDev: 0 //location.hostname === 'localhost'
    };
  },

  async mounted() {
    this.timeOut =
      !this.isDev &&
      setTimeout(async () => {
        this.check();
      }, 10000);
  },
  methods: {
    async check() {
      try {
        this.exporting =
          (
            await this.ajaxRequest.get(this.url, {
              params: this.params,
              paramsSerializer: encodeOpts
            })
          ).data * 100;
        if (!this.timeoutTime) {
          this.timeoutTime = this.exporting ? 10000 : 60000;
          this.timeOut = setInterval(() => {
            this.check();
          }, this.timeoutTime);
        }
      } catch (e) {
      } finally {
        this.loaded = true;
      }
    },
    async startExporting() {
      try {
        this.exporting = 0.01;
        this.exporting = await this.ajaxRequest.post(this.url, this.params).data;
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    ...mapGetters(['loggedInUser']),
    ajaxRequest() {
      return this.isService ? api_services() : this.$http;
    },
    canExportFeed() {
      return (
        this.url !== `/feeds` ||
        (this.url === `/feeds` &&
          !!this.loggedInUser.roles.find(
            (e) => e.settings && e.settings.general && e.settings.general.includes('can-build-product-feed')
          ))
      );
    }
  },
  destroyed() {
    if (this.timeOut) clearInterval(this.timeOut);
  }
};
</script>
